// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2bKdb","detailsBorder":"styles_detailsBorder__3kWA0"};